import { IconsProps } from 'src/svgs/Viagogo/icon-types';
import { SvgWrapper } from 'src/svgs/Viagogo/svg-wrapper/icon-wrapper';

export function NavWhatsNewIcon(props: IconsProps) {
  return (
    <SvgWrapper {...props}>
      <g transform="translate(2 2)">
        <path
          d="M16 6.66797C17.3807 6.66797 18.5 5.54868 18.5 4.16797C18.5 2.78726 17.3807 1.66797 16 1.66797C14.6192 1.66797 13.5 2.78726 13.5 4.16797C13.5 5.54868 14.6192 6.66797 16 6.66797Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 10V12.5C17.5 15.2614 15.2614 17.5 12.5 17.5H7.5C4.73857 17.5 2.5 15.2614 2.5 12.5V7.5C2.5 4.73857 4.73857 2.5 7.5 2.5H10"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </SvgWrapper>
  );
}
